module.exports = __webpack_public_path__ + "static/media/exceptional_viewer_experience.f05854fb.svg";